import { FooterLink } from '@siemens/component-lib';

export const footerLinks: FooterLink[] = [
    { key: 'global', url: 'https://siemens.com', text: 'Siemens AG © ' + new Date().getFullYear() },
    {
        key: 'corporate-information',
        url: 'https://www.siemens.com/global/en/general/legal.html',
        text: 'footer.corporate-information'
    },
    {
        key: 'privacy-notice',
        url: 'https://siemens.com/global/en/general/privacy-notice.html',
        text: 'footer.privacy-notice'
    },
    {
        key: 'cookie-notice',
        url: 'https://www.siemens.com/global/en/general/cookie-notice.html',
        text: 'footer.cookie-notice'
    },
    {
        key: 'terms-of-use',
        url: 'https://www.siemens.com/global/en/general/terms-of-use.html',
        text: 'footer.terms-of-use'
    },
    {
        key: 'digital-id',
        url: 'https://siemens.com/global/en/general/digital-id.html',
        text: 'footer.digital-id'
    }
];
